import React from 'react'

import FAIcon from '../components/FAIcon'

import Select from './controls/Select'

const TranslationServiceSelecter = ({ onChange, name, value, services, onAddRequested, onEditRequested, ...props }) => {
  const options = services.map(x => ({ value: x.id, label: x.name }))
  const selectedValue = options.find(x => x.value === value)
  // Ensure we pass null if no option matches (to fully clear/reset the underlying Select)
  const safeValue = selectedValue || null

  return (
    <div>
      <div className="d-inline-block col-10 px-0">
        <Select
          {...props}
          name={name}
          id={name}
          value={safeValue}
          placeholder="Search translation services"
          options={options}
          onChange={onChange}
          footerText={onAddRequested ? '+ Add new translation service...' : null}
          onFooterClick={onAddRequested}
          noOptionsMessage={() => 'No results found'}
        />
      </div>
      <button
        type="button"
        className="fa-button"
        onClick={() => {
          if (onEditRequested && selectedValue) {
            onEditRequested(selectedValue.value)
          }
        }}
        disabled={!selectedValue}
      >
        <FAIcon
          type="fas"
          name="pen"
          className={`d-inline-block col-2 ${!selectedValue ? 'text-muted' : 'text-primary'}`}
        />
      </button>
    </div>
  )
}

export default TranslationServiceSelecter
